<template>
<section>
  <div class="top-container">
    <div class="top-content main-content-wrap">
      <div class="left-container">
        <a href="https://www.vip.com/" target="_blank">
          唯品会首页
        </a>
      </div>
      <div class="right-container">
        <span v-if="isLogin">
          <a>{{userInfo.username || '唯品会会员'}}</a>
          |
          <a href="javascript:;" @click="loginOut()">退出</a>
        </span>
        <span v-else>
          <a :href="`https://passport.vip.com/login?src=${locationHref}`" title="请登录" @click="goLogin()">请登录</a> |
          <a href="https://passport.vip.com/register" title="注册">注册</a>
        </span>
      </div>
    </div>
  </div>
  <Nav @changeNav="changeNav"></Nav>
  <Search ref="search"></Search>
</section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Nav from './nav.vue'
import Search from './search.vue'
import {mapMutations} from 'vuex'
import {
  clearCookies,
  setCookie,
  getCookie
} from '@/lib'
export default {
  name: '',
  data () {
    return {
      locationHref: encodeURIComponent(window.location.href)
    }
  },
  computed: {
    ...mapState(['userInfo', 'isLogin'])
  },
  beforeMount () {
    setCookie('XSRF-TOKEN', '', -1, 'vip.com')
    setCookie('XSRF-TOKEN', '', -1, 'rule.vip.com')
    clearTimeout(window.ruleTimer)
  },
  beforeCreate () {
    setCookie('rule_login_type', window.sessionStorage.getItem('rule_login_type'), 8 * 1000, 'vip.com')
  },
  mounted () {
    this.$store.dispatch('getUserInfo').catch(() => {
      if (!getCookie('reload')) {
        setCookie('reload', 'true', 1)
        this.loginOut()
      }
    })
    this.$store.dispatch('signIn')
  },
  methods: {
    goLogin () {
      setCookie('rule_login_type', '2', 8 * 1000, 'vip.com')
      window.sessionStorage.setItem('rule_login_type', '2')
    },
    refreshCache () {
      clearTimeout(window.ruleTimer)
      window.ruleTimer = setTimeout(() => {
        setCookie('rule_login_type', window.sessionStorage.getItem('rule_login_type'), 8 * 1000, 'vip.com')
        this.refreshCache()
      }, 5000)
    },
    ...mapMutations('rule', ['updatePhrase']),
    ...mapActions(['signOut']),
    loginOut () {
      this.signOut().then(() => {
        clearCookies()
        setCookie('rule_login_type', '2', 8 * 1000, 'vip.com')
        window.sessionStorage.setItem('rule_login_type', '2')
        window.location.href = `https://passport.vip.com/login?src=${window.encodeURIComponent(window.location.href)}`
      })
      // window.location.href = `https://passport.vip.com/logout?src=${window.encodeURIComponent(window.location.href)}`
    },
    changeNav () {
      this.$refs.search.phrase = ''
      this.updatePhrase('')
    }
  },
  components: {
    Nav,
    Search
  }
}
</script>

<style lang="scss" scoped>
.top-container {
  background: #F5F5F5;
  height: 30px;
  line-height: 30px;
  .top-content  {
    .left-container {
      float: left;
    }
    .right-container {
      float: right;
      a {
        margin-right: 5px;
        margin-left: 5px;
      }
    }
  }
}
</style>
